/**
 * NetworkCurrencyConverter entity class
 */

/**
 * NetworkCurrencyConverterFactory
 * returns NetworkCurrencyConverter entity class
 *
 * @class NetworkCurrencyConverterFactory
 * @memberof mwApp
 * @see mwApp
 * @return {Function} {@link models.NetworkCurrencyConverter} class
 *
 * @ngdoc factory
 * @name mwApp.factory:NetworkCurrencyConverterFactory
 */
/* @ngInject */
export default function NetworkCurrencyConverterFactory ($http, alertLiteSvc, CurrencyConverter) {
  /* === NetworkCurrencyConverter class === */

  /**
   * NetworkCurrencyConverter model
   *
   * @class NetworkCurrencyConverter
   * @classdesc NetworkCurrencyConverter model
   * @memberof models
   * @see models
   * @extends models.CurrencyConverter
   * @param {Object} [object] - initial object, containing NetworkCurrencyConverter entity fields
   * @return {models.NetworkCurrencyConverter} NetworkCurrencyConverter entity
   */
  function NetworkCurrencyConverter () {
    var obj = CurrencyConverter.apply(this, arguments)
    if (obj) {
      return obj
    }
  }
  NetworkCurrencyConverter.prototype = Object.create(CurrencyConverter.prototype)
  NetworkCurrencyConverter.prototype.constructor = NetworkCurrencyConverter

  /* === NetworkCurrencyConverter instance methods & fields === */

  Object.assign(NetworkCurrencyConverter.prototype, {

    /**
     * Url template
     *
     * @memberof models.NetworkCurrencyConverter#
     * @type {String}
     */
    _urlTemplate: 'api/networks/{{::$network.id}}/currencyconverters/{{::id}}',

    /**
     * Set NetworkCurrencyConverter to use system default (or not use), performing PATCH request to the server
     *
     * @memberof models.NetworkCurrencyConverter#
     * @return {Promise} promise
     */
    _systemDefault: function () {
      return $http.patch(this._url, this.useSystemDefault ? '"USE_SYSTEM_DEFAULT"' : '"NOT_USE_SYSTEM_DEFAULT"')
        .then(
          response => {
            this._weakCopy(response.data)
            return response
          }
        ).catch(
          rejection => {
            this.useSystemDefault = !this.useSystemDefault
            return alertLiteSvc.alertError(rejection)
          }
        )
    }

  })

  // copy all static methods from Entity class
  Object.assign(NetworkCurrencyConverter, CurrencyConverter)
  NetworkCurrencyConverter._name = 'NetworkCurrencyConverter'
  NetworkCurrencyConverter.init()

  return NetworkCurrencyConverter
}
